
export const TLM_KEYS = 'vpp,broadcast,streaming,entity,channel,genre'
export const TLM_FIRST_PAGE = 1
export const TLM_PAGE_SIZE = 5
export const BRAND_TLM_PAGE_SIZE = 10
export const TLM_VPP = 'vpp'
export const TLM_BROADCAST = 'broadcast'
export const TLM_STREAMING = 'streaming'
export const TLM_ENTITY = 'entity'
export const TLM_CHANNEL = 'channel'
export const TLM_GENRE = 'genre'
export const TLM_BRAND = 'brand'
export const TLM_VPP_BRAND = 'vppBrand'
export const TLM_LEFT = 'left'
export const TLM_RIGHT = 'right'
export const TLM_LIMIT = 1

//topic sub types
export const MOVIE = 'Movie'
export const SHOW = 'Show'
export const PEOPLE = 'People'
export const BRAND = 'Brand'
export const MUSIC = 'Music'
export const LIFESTYLE = 'Lifestyle'
export const CHANNEL = 'Channel'
export const VIDEO = 'Video'
export const GAMING = 'Gaming'

//filter type
export const AND = 'AND'
export const OR = 'OR'
export const NOT = 'NOT'